import React from 'react';

/**
 * Card wrapper + header for list pages, styled to match CLP's
 * /admin/attendances table design (borderless card, tinted icon chip).
 */
const DataTableCard = ({ icon, title, subtitle, actions, children }) => {
  return (
    <div className="card card-body border-0 shadow-sm rounded-4">
      <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mb-4">
        <div className="d-flex align-items-center gap-3">
          {icon && (
            <div
              className="bg-primary bg-opacity-10 d-flex align-items-center justify-content-center rounded-3"
              style={{ width: '40px', height: '40px' }}
            >
              <i className={`bi ${icon} text-primary fs-5`}></i>
            </div>
          )}
          <div>
            <h1 className="h5 fw-bold mb-0 text-dark">{title}</h1>
            {subtitle && (
              <p
                className="text-muted mb-0 d-none d-lg-block"
                style={{ fontSize: '0.75rem' }}
              >
                {subtitle}
              </p>
            )}
          </div>
        </div>
        {actions && (
          <div className="d-flex flex-wrap align-items-center gap-3 ms-md-auto">
            {actions}
          </div>
        )}
      </div>

      {children}

      <style>{`
        .extra-small { font-size: 0.7rem; }
        .transition-all { transition: all 0.2s ease; }
        .table-hover tbody tr:hover {
          background-color: rgba(var(--bs-primary-rgb), 0.03) !important;
          transform: scale(0.998);
        }
      `}</style>
    </div>
  );
};

export default DataTableCard;
